// extracted by mini-css-extract-plugin
export default {"pageContainer":"PageContainer_pageContainer__-6glL","contentWrapper":"PageContainer_contentWrapper__maZwa"};